// import { useState } from 'react';
import LocationIcon from '../../../assets/icons/consultants/location.svg';
import StarIcon from '../../../assets/icons/consultants/star.svg';
import LikeIcon from '../../../assets/icons/consultants/like.svg';
import CheckIcon from '../../../assets/icons/consultants/check.svg';
import { Col, FlexboxGrid, Button } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AdminConsultantRegisterModel } from '../../../models/admin';
import { handleGetAdminConsultantsRegisters } from '../../../api-handler/admin';
import { CustomLoader } from './../../../components/basic/loader';

export const ConsultantsList = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<AdminConsultantRegisterModel[]>([]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const res = await handleGetAdminConsultantsRegisters();

      console.log(res);
      if (res.ok) {
        setData(res.data);
        console.log(res.data);
      }
      setLoading(false);
    })();
  }, []);
  return (
    <FlexboxGrid>
      {loading ? (
        <CustomLoader />
      ) : (
        <>
          {data.map((item) => {
            return (
              <FlexboxGrid.Item
                key={item.ID.toString()}
                as={Col}
                colspan={24}
                sm={24}
                md={12}
                className="max-w-[100%] mb-3">
                <div className="bg-[--rs-white] border-[--rs-primary-300] rounded-lg border-[1px] p-4 w-full">
                  <div className="flex">
                    <div className="w-[100px] aspect-square rounded-full bg-[--rs-primary-50]"></div>
                    <div className="mr-3 mt-5">
                      <h4 className="text-h4 text-[--rs-primary-800]">{item.FullName}</h4>
                      <p className="text-b1 mb-0 mt-1 text-[--rs-primary-400]">{item.Job}</p>
                    </div>
                    <div className="flex items-center mr-auto mb-10">
                      <img src={LocationIcon} alt="location" />
                      <p className="text-b1 text-[--rs-primary-400] ml-3">{item.City}</p>
                    </div>
                  </div>
                  <div className="flex justify-between mt-4">
                    <div className="flex items-center justify-center w-full">
                      <img src={StarIcon} alt="star" />
                      <span className="text-b2 text-[--rs-primary-500] mr-1">
                        <strong>4.9</strong> (21 نظر)
                      </span>
                    </div>
                    <div className="flex items-center justify-center w-full">
                      <img src={LikeIcon} alt="like" />
                      <span className="text-b2 text-[--rs-success-800] mr-1">
                        100٪پیشنهاد کاربران
                      </span>
                    </div>
                    <div className="flex items-center justify-center w-full">
                      <img src={CheckIcon} alt="check" />
                      <span className="text-b2 text-[--rs-info-700] mr-1">120 نوبت موفق</span>
                    </div>
                  </div>
                  <div className="flex items-center mt-6">
                    <Button
                      appearance="primary"
                      className="mx-auto min-w-[50%] mb-2 inline-block"
                      type="button"
                      onClick={() => navigate(`/consultants/${item.Username}`)}>
                      رزرو وقت مشاوره
                    </Button>
                  </div>
                </div>
              </FlexboxGrid.Item>
            );
          })}
        </>
      )}
    </FlexboxGrid>
  );
};
